import React from "react";
import SectionAbout from "./About.styled";
import {Color} from "../Common/Colors";
import H2 from "../Common/H2.styled";
import Container from "../Common/Container.styled";
import StyledAboutGrid from "./AboutGrid.styled";
import Img from "../Common/Img.styled";
import Kevin from "../../images/_DSC8422_370x780.png";

const About = () => {

    return (
        <SectionAbout id="about" backgroundColor={Color.lavender}>
            <H2>About Me</H2>
            <Container>
                <StyledAboutGrid>
                    <div className="about_img-selfportrait">
                        <Img src={Kevin} alt="Kevin Effertz"/>
                    </div>
                    <div className="about_letter">
                        <p className="about_paragraph">Hi,<br/><br/>Welcome to my personal web page. I have over 30
                            years of software and data engineering experience building and supporting complex enterprise
                            editorial content management and publishing systems in the legal industry.</p>
                        <p className="about_paragraph">Digital technology continues to revolutionize the world. Cloud
                            computing, Internet of Things(IoT), Big Data Analytics, and advances in Artificial
                            Intelligence(AI) are converging causing our world to be more interconnected, leading to new
                            ways in which we communicate, know information, engage people, and relate to our
                            surroundings.</p>
                        <p className="about_paragraph">Organizations continue to increase their adoption of low-code/no
                            code platforms, citizen development, and digital video to build web applications faster,
                            improve their competive edge, and automate their business processes.</p>
                        <p className="about_paragraph">My strong technical aptitude, exceptional customer service,
                            excellent collaboration skills and desire to keep abreast of digital technology trends make
                            me an excellent candidate to assist you with strategizing and implementing your digital
                            transformation needs.</p>
                        <p className="about_paragraph">I appreciate you taking time to view my professional and personal
                            background!</p>
                        <p className="about_paragraph">Kevin Effertz</p>
                    </div>
                </StyledAboutGrid>
            </Container>
        </SectionAbout>
    );
}

export default About;